<!-- showAccordion on: the sections sit in the accordion housing. Off: the same cards are listed flat, with no housing
     around them (questionnaire-summary-new prototype) - so no section titles, nothing collapsed and no tour tip 3 -->
@if (showAccordion) {
  <div class="accordion accordion--controls">
    @if (context?.show_policyholder && profile.length > 0) {
      <div class="accordion__item">
        <a href="#traffic-profile" class="accordion__title" data-toggle="collapse" aria-expanded="true">
          <div class="accordion__title-text">
            <img src="{{profileImage}}" alt="" class="icon icon--lg">
            <h5>Your profile</h5>
          </div>
          <div class="accordion__title-caret">
            <svg class="icon"><use xlink:href="#chevron-down-small"></use></svg>
          </div>
        </a>
        <div class="accordion__body collapse show" id="traffic-profile">
          <div class="accordion__content">
            <ng-container *ngTemplateOutlet="profileCard"></ng-container>
          </div>
        </div>
      </div>
    }
    @if (context?.show_locations) {
      <div class="accordion__item">
        <a href="#traffic-locations" class="accordion__title" data-toggle="collapse" aria-expanded="true">
          <div class="accordion__title-text">
            <img src="{{locationsImage}}" alt="" class="icon icon--lg">
            <h5>Your Locations</h5>
          </div>
          <div class="accordion__title-caret">
            <svg class="icon"><use xlink:href="#chevron-down-small"></use></svg>
          </div>
        </a>
        <div class="accordion__body collapse show" id="traffic-locations">
          <div class="accordion__content">
            <ng-container *ngTemplateOutlet="locationsCard"></ng-container>
          </div>
        </div>
      </div>
    }
    @for (group of grouping; track group.group_id; let i = $index) {
      <div class="accordion__item" [ngClass]="i === 0 ? 'position-relative': null">
        @if (classCount > 1) {
          <a href="#group-{{ group?.group_id }}" class="accordion__title " [ngClass]="i === 0 ? null : 'collapsed'" data-toggle="collapse" [attr.aria-expanded]="i === 0 ? 'true' : 'false'">
            <div class="accordion__title-text">
              @if (group?.image_url) {
                <!-- group icon: image_url of the group's first class. Not in the prototype beyond the first grouping -->
                <img src="{{group?.image_url}}" alt="" class="icon icon--lg">
              }
              <h5>{{group?.group_name}}</h5>
            </div>
            <div class="accordion__title-caret">
              <svg class="icon"><use xlink:href="#chevron-down-small"></use></svg>
            </div>
          </a>
        }
        <div class="accordion__body collapse" [ngClass]="i === 0 ? 'show' : null" id="group-{{group?.group_id}}">
          <div class="accordion__content">
            <ng-container *ngTemplateOutlet="groupCards; context: { $implicit: group }"></ng-container>
          </div>
        </div>
        @if (i === 0) {
          <div class="guide guide--traffic-cover-location" id="guide-1-tip-3" >
            <div class="guide__close">
              <svg class="icon">
                <use xlink:href="#close-circle-small"></use>
              </svg>
            </div>
            <div class="guide__content">
              <p>For each location, include location-based coverage. Add as much cover as you like.
              </p>
            </div>
            <div class="guide__tray">
              <div class="guide__progress">3 / 4</div>
              <div class="guide__btn">
                <a href="#guide-1-tip-4" data-guide-btn="next"
                class="button button--sm button--everything">Next</a>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
} @else {
  @if (context?.show_policyholder && profile.length > 0) {
    <ng-container *ngTemplateOutlet="profileCard"></ng-container>
  }
  @if (context?.show_locations) {
    <ng-container *ngTemplateOutlet="locationsCard"></ng-container>
  }
  @for (group of grouping; track group.group_id) {
    <ng-container *ngTemplateOutlet="groupCards; context: { $implicit: group }"></ng-container>
  }
}
<!-- section bodies, the same in both layouts -->
<ng-template #profileCard>
  <div class="traffic-cop-summary">
    <div class="traffic-cop-summary__body">
      <div class="traffic-cop-summary__header">
        <div class="traffic-cop-summary__header-title">
          <div class="traffic-cop-summary__header-left">
            <div class="traffic-cop-summary__header-icon">
              <img src="{{profileImage}}" alt="" class="icon">
            </div>
            <h6>Policyholder</h6>
          </div>
          <div class="traffic-cop-summary__header-actions">
            <!-- DUMMY: completion status - not in getSuperTrafficCop -->
            <div class="indicator indicator--positive">
              <svg class="icon"><use xlink:href="#check-small"></use></svg>
              <span>Complete</span>
            </div>
          </div>
        </div>
      </div>
      <div class="traffic-cop-summary__items">
        @for (entry of profile; track $index) {
          <div class="traffic-cop-summary-item">
            <div class="traffic-cop-summary-item__content">
              @if (entry?.name) {
                <p><strong>{{entry?.name}}</strong></p>
              }
              @if (entry?.is_main) {
                <div class="indicator indicator--info">
                  <span>{{entry?.role_label}}</span>
                </div>
              } @else {
                <p><small class="text-color-grey-7">{{entry?.role_label}}</small></p>
              }
            </div>
            @if (entry?.edit || entry?.del) {
              <!-- DUMMY: no remove action for profile entries yet - Remove only follows the del flag -->
              <div class="traffic-cop-summary-item__actions stacked-buttons">
                <!-- mobile buttons -->
                @if (entry?.del) {
                  <button type="button" class="icon-button icon-button--lg d-md-none" title="Remove">
                    <svg class="icon"><use xlink:href="#trash-bin"></use></svg>
                  </button>
                }
                @if (entry?.edit) {
                  <button type="button" class="icon-button icon-button--lg d-md-none" title="Edit" (click)="editProfile()">
                    <svg class="icon"><use xlink:href="#edit"></use></svg>
                  </button>
                }
                <!-- desktop buttons -->
                @if (entry?.del) {
                  <button type="button" class="stacked-button stacked-button--grey d-none d-md-flex">
                    <div class="stacked-button__icon">
                      <svg class="icon"><use xlink:href="#trash-bin"></use></svg>
                    </div>
                    <div class="stacked-button__label">Remove</div>
                  </button>
                }
                @if (entry?.edit) {
                  <button type="button" class="stacked-button stacked-button--grey d-none d-md-flex" (click)="editProfile()">
                    <div class="stacked-button__icon">
                      <svg class="icon"><use xlink:href="#edit"></use></svg>
                    </div>
                    <div class="stacked-button__label">Edit</div>
                  </button>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</ng-template>
<ng-template #locationsCard>
  <div class="traffic-cop-summary">
    <div class="traffic-cop-summary__body">
      <div class="traffic-cop-summary__header">
        <div class="traffic-cop-summary__header-title">
          <div class="traffic-cop-summary__header-left">
            <div class="traffic-cop-summary__header-icon">
              <img src="{{locationsImage}}" alt="" class="icon">
            </div>
            <h6>{{locationsTitle}}</h6>
          </div>
          <div class="traffic-cop-summary__header-actions position-relative">
            <button type="button" class="button button--primary" (click)="addLocation.emit()">
              <svg class="icon"><use xlink:href="#plus-small"></use></svg>
              <span>Add</span>
            </button>
            <div class="guide guide--top-right guide--traffic-add-locations" id="guide-1-tip-1">
              <div class="guide__close">
                <svg class="icon">
                  <use xlink:href="#close-circle-small"></use>
                </svg>
              </div>
              <div class="guide__content">
                <p>You can add as many locations as you'd like.</p>
              </div>
              <div class="guide__tray">
                <div class="guide__progress">1 / 4</div>
                <div class="guide__btn">
                  <a href="#guide-1-tip-2" data-guide-btn="next" class="button button--sm button--everything">Next</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      @if (context?.show_existing_locations && locations.length > 0) {
        <div class="traffic-cop-summary__items">
          @for (location of locations; track location.location_id) {
            <div class="traffic-cop-summary-item">
              <div class="traffic-cop-summary-item__content">
                <p><strong>{{location?.location_name}}</strong></p>
                @if (location?.address) {
                  <p><small class="text-color-grey-7">{{location?.address}}</small></p>
                }
              </div>
              <!-- no per-location flags in getSuperTrafficCop: Edit always shows, Remove while another location is left -->
              <div class="traffic-cop-summary-item__actions stacked-buttons">
                <!-- mobile buttons -->
                @if (locations.length > 1) {
                  <button type="button" class="icon-button icon-button--lg d-md-none" title="Remove" (click)="askRemoveLocation(location)">
                    <svg class="icon"><use xlink:href="#trash-bin"></use></svg>
                  </button>
                }
                <button type="button" class="icon-button icon-button--lg d-md-none" title="Edit" (click)="editLocation.emit(location)">
                  <svg class="icon"><use xlink:href="#edit"></use></svg>
                </button>
                <!-- desktop buttons -->
                @if (locations.length > 1) {
                  <button type="button" class="stacked-button stacked-button--grey d-none d-md-flex" (click)="askRemoveLocation(location)">
                    <div class="stacked-button__icon">
                      <svg class="icon"><use xlink:href="#trash-bin"></use></svg>
                    </div>
                    <div class="stacked-button__label">Remove</div>
                  </button>
                }
                <button type="button" class="stacked-button stacked-button--grey d-none d-md-flex" (click)="editLocation.emit(location)">
                  <div class="stacked-button__icon">
                    <svg class="icon"><use xlink:href="#edit"></use></svg>
                  </div>
                  <div class="stacked-button__label">Edit</div>
                </button>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</ng-template>
<ng-template #groupCards let-group>
  @for (cover of getGroupingClasses(group); track cover.cent_aq_answer_id) {
    <ng-container *ngTemplateOutlet="coverCard; context: { $implicit: cover }"></ng-container>
    @if (classCount > 1) {
      <!-- not in the prototype: dependent cover is listed as full cards under its parent, not in a nested tray -->
      @for (child of getGroupingClasses(group, cover); track child.cent_aq_answer_id) {
        <ng-container *ngTemplateOutlet="coverCard; context: { $implicit: child, parent: cover }"></ng-container>
      }
    }
  }
</ng-template>
<!-- cover card. parent is set for dependent cover, which keeps the old rules: item actions follow the parent's del/edit, edit opens the class.
     A locked card has no Read more / See wording row and no ITK - why it is locked goes in the footer instead -->
<ng-template #coverCard let-cover let-parent="parent">
  <div class="traffic-cop-summary" [class.is-included]="cover?.included === 1" [class.is-active]="cover?.del === 1 || cover?.edit === 1"
    [class.is-locked]="isLocked(cover)">
    <div class="traffic-cop-summary__body">
      <div class="traffic-cop-summary__header">
        <div class="traffic-cop-summary__header-title">
          <div class="traffic-cop-summary__header-left">
            <div class="traffic-cop-summary__header-icon">
              <img src="{{cover?.image_url}}" alt="" [fallbackImage]="'assets/class/sm-0.svg'" class="icon">
            </div>
            <h6>{{cover?.answer}}</h6>
          </div>
          <div class="traffic-cop-summary__header-actions">
            @if (cover?.included === 1) {
              <div class="indicator indicator--info">
                <span>Included</span>
              </div>
            } @else if ((parent || !cover?.item_detail) && (cover?.del === 0 || cover?.edit === 0) && cover?.disabled !== 1) {
              <button type="button" class="button button--primary" (click)="addCover(cover)">
                <svg class="icon"><use xlink:href="#plus-small"></use></svg>
                <span>Add</span>
              </button>
            } @else if (cover?.add === 1) {
              <button type="button" class="button button--primary" (click)="addAnother(cover)">
                <svg class="icon"><use xlink:href="#plus-small"></use></svg>
                <span>Add</span>
              </button>
            } @else if (cover?.item_detail) {
              <div class="indicator indicator--positive">
                <svg class="icon"><use xlink:href="#check-small"></use></svg>
                <span>Added</span>
              </div>
            } @else {
              <div class="indicator indicator--warning">
                <svg class="icon"><use xlink:href="#lock"></use></svg>
                <span>Locked</span>
              </div>
            }
          </div>
        </div>
        <div class="traffic-cop-summary__header-content" #reveal [class.is-revealed]="cover?._revealed">
          <p>{{cover?.info_comment}}</p>
        </div>
        @if (!parent && !isLocked(cover)) {
          <div class="traffic-cop-summary__header-content-actions">
            @if (canReveal(cover, reveal)) {
              <a href="javascript:;" class="link" (click)="cover._revealed = !cover._revealed">{{cover?._revealed ? 'Read less' : 'Read more'}}</a>
            }
          </div>
        }
      </div>
      @if (cover?.item_detail) {
        <div class="traffic-cop-summary__items">
          @for (item of cover?.item_detail; track $index) {
            <div class="traffic-cop-summary-item">
              <div class="traffic-cop-summary-item__content">
                <p><strong>{{item?.description}}</strong></p>
                @if (item?.sub_description) {
                  <!-- the proc leaves sub_description out when it would only repeat the description -->
                  <p><small class="text-color-grey-7">{{item?.sub_description}}</small></p>
                }
              </div>
              <div class="traffic-cop-summary-item__price">
                <p class="price price--sm"><strong>{{item?.prem_value}}</strong>/{{questionService.currency?.display_freq}}</p>
              </div>
              <div class="traffic-cop-summary-item__actions stacked-buttons">
                <!-- mobile buttons -->
                @if (parent ? parent?.del === 1 : item?.delete === 1) {
                  <button type="button" class="icon-button icon-button--lg d-md-none" title="Remove" (click)="removeCover(cover, item?.item_id, item)">
                    <svg class="icon"><use xlink:href="#trash-bin"></use></svg>
                  </button>
                }
                @if ((parent || cover)?.edit === 1) {
                  <button type="button" class="icon-button icon-button--lg d-md-none" title="Edit" (click)="parent ? editModal(cover) : editModal(cover, item?.item_id)">
                    <svg class="icon"><use xlink:href="#edit"></use></svg>
                  </button>
                }
                <!-- desktop buttons -->
                @if (parent ? parent?.del === 1 : item?.delete === 1) {
                  <button type="button" class="stacked-button stacked-button--grey d-none d-md-flex" (click)="removeCover(cover, item?.item_id, item)">
                    <div class="stacked-button__icon">
                      <svg class="icon"><use xlink:href="#trash-bin"></use></svg>
                    </div>
                    <div class="stacked-button__label">Remove</div>
                  </button>
                }
                @if ((parent || cover)?.edit === 1) {
                  <button type="button" class="stacked-button stacked-button--grey d-none d-md-flex" (click)="parent ? editModal(cover) : editModal(cover, item?.item_id)">
                    <div class="stacked-button__icon">
                      <svg class="icon"><use xlink:href="#edit"></use></svg>
                    </div>
                    <div class="stacked-button__label">Edit</div>
                  </button>
                }
              </div>
              @if (item?.addons_bar) {
                <!-- DUMMY: add-on actions - the counter, Edit and Add are not wired to the getItemAddOns picker yet -->
                <div class="traffic-cop-summary-item__tray">
                  <a class="traffic-cop-summary-item__tray-counter" href="javascript:;" data-sidesheet-trigger="benefits">
                    <div class="counter-badge counter-badge--grey">{{item?.addons_count}}</div>
                    <small>Add-ons</small>
                  </a>
                  @if (item?.addons_included > 0) {
                    <!-- not in the prototype: the item also has add-ons that come included -->
                    <div class="indicator indicator--info">
                      <span>Included</span>
                    </div>
                  }
                  <div class="traffic-cop-summary-item__tray-actions">
                    @if (item?.addons_edit) {
                      <a href="javascript:;" class="link link--sm">
                        <span class="font-normal">Edit</span>
                        <svg class="icon">
                          <use xlink:href="#edit"></use>
                        </svg>
                      </a>
                    }
                    @if (item?.addons_add) {
                      <a href="javascript:;" class="link link--sm">
                        <span class="font-normal">Add</span>
                        <svg class="icon">
                          <use xlink:href="#plus-small"></use>
                        </svg>
                      </a>
                    }
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
      @if (!parent && !isLocked(cover) && getItkItems(cover).length > 0) {
        <div class="traffic-cop-summary__itk">
          <app-itk [items]="getItkItems(cover)"></app-itk>
        </div>
      }
      @if (!parent && !isLocked(cover)) {
        <!-- DUMMY: discount banner (questionnaire-summary-new prototype) - placeholder copy on every cover card that is not locked,
             in either layout. getSuperTrafficCop sends no discount data yet, and the banner does not open anything -->
        <a href="javascript:;" class="discount-banner">
          <div class="discount-banner__bg">
            <!-- the gradient id carries the answer id: with one id for all, every banner paints from the first card's gradient
                 and loses its background whenever that card is not displayed -->
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 77 86">
              <circle cx="-30.5" cy="42.5" r="85.5" [attr.fill]="'url(#discount-banner-bg-' + cover?.cent_aq_answer_id + ')'"></circle>
              <circle cx="-30.5" cy="42.5" r="60.5" fill="#FB7268" fill-opacity="0.04"></circle>
              <defs>
                <linearGradient [attr.id]="'discount-banner-bg-' + cover?.cent_aq_answer_id" x1="55" y1="42.5" x2="1.5" y2="42.5" gradientUnits="userSpaceOnUse">
                  <stop stop-color="#FB7268" stop-opacity="0.02"></stop>
                  <stop offset="1" stop-color="#FB7268" stop-opacity="0.1"></stop>
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div class="discount-banner__content">
            <div class="discount-banner__icon">
              <svg class="icon icon--lg"><use xlink:href="#discount"></use></svg>
            </div>
            <div class="discount-banner__copy">
              <h6>Stand to get 15% off</h6>
              <p class="text-color-grey-7">You could earn a discount by insuring more than one vehicle with the same primary driver!</p>
            </div>
          </div>
          <div class="discount-banner__actions">
            <button type="button" class="icon-button icon-button--sm">
              <svg class="icon"><use xlink:href="#chevron-right"></use></svg>
            </button>
          </div>
        </a>
      }
    </div>
    @if (isLocked(cover) && (parent || cover)?.dependency_label) {
      <!-- dependent cover is locked by the cover it depends on, whose row holds the label; any other locked cover carries its own -->
      <div class="traffic-cop-summary__msg">
        <app-highlight-message
          icon="help-filled"
          [title]="'Why is it locked?'"
          [message]="(parent || cover)?.dependency_label"
          additionalClasses="notice--flush">
        </app-highlight-message>
      </div>
    }
  </div>
</ng-template>
@if (classCount > 1) {
  <hr class="hr--bdr mb-0">
}
<h5 class="mt-30 mb-20 position-relative">
  {{nonLocation[0]?.group_name}}
  <div class="guide guide--traffic-non-location" id="guide-1-tip-4">
    <div class="guide__close">
      <svg class="icon">
        <use xlink:href="#close-circle-small"></use>
      </svg>
    </div>
    <div class="guide__content">
      <p>You can also add non-location-based coverage that applies to the entire policy. You
      only need to add this type of cover once.</p>
    </div>
    <div class="guide__tray">
      <div class="guide__progress">4 / 4</div>
      <div class="guide__btn">
        <a href="#" data-guide-btn="end" class="button button--sm button--everything">Got
        it</a>
      </div>
    </div>
  </div>
</h5>
<div class="question-pull question-pull--slider">
  <ngx-slick-carousel class="slider slider--cover slider--mh" id="cover-slider" [config]="slideConfig">
    @for (class of nonLocation; track class; let i = $index) {
      <div ngxSlickItem [attr.data-slick-index]="i" class="slider__slide"
        >
        <div class="slider__slide-inner">
          <label class="custom-input custom-input--radio custom-input--icon-cover-alt is-active">
            <input type="checkbox" [disabled]="class?.disabled === 1 ? 'disabled':null" name="checkbox-example-1"
              (click)="checkRadio(class, $event)" />
              <span class="custom-input__label">
                <img src="/assets/icn/class/sm-benefit.svg" class="icon" alt="" />
                <h5 class="font-16">{{class?.answer}}</h5>
                <p class="readmore readmore--inline" data-widget="ReadMore" data-splitlength="15"
                data-more-text="read more" data-less-text="read less" [innerHTML]="class?.info_comment"></p>
                @if (class?.del === 1) {
                  <span class="custom-input__actions">
                    <a href="javascript:;" data-toggle="modal" (click)="removeCover(class, 1)"
                      class="icon-hover icon-hover--mobile-label" data-tooltip="tooltip" data-placement="top" title=""
                      data-original-title="Remove Cover" tabindex="0">
                      <svg class="icon icon--sm">
                        <use xlink:href="#trash-bin"></use>
                      </svg>
                      <strong>Remove</strong>
                    </a>
                    @if (class?.edit === 1) {
                      <a href="javascript:;" (click)="editModal(class)"
                        class="icon-hover icon-hover--mobile-label" data-tooltip="tooltip" data-placement="top" title=""
                        data-original-title="Edit Cover" tabindex="0">
                        <svg class="icon icon--sm">
                          <use xlink:href="#edit-underline"></use>
                        </svg>
                        <strong>Edit</strong>
                      </a>
                    }
                  </span>
                }
              </span>
              @if (class?.edit === 0) {
                <span class="custom-input__indi"></span>
              }
              @if (class?.edit === 1 && class?.item_detail) {
                <span class="custom-input__price">
                  <p><strong>{{class?.item_detail[0]?.prem_value}}</strong>/{{questionService.currency?.display_freq}}</p>
                </span>
              }
            </label>
          </div>
        </div>
      }
    </ngx-slick-carousel>
    <!-- <div class="slider slider--cover slider--mh" id="cover-slider">
    <div class="slider__slide" *ngFor="let class of nonLocation">
      <div class="slider__slide-inner">
        <label class="custom-input custom-input--radio custom-input--icon-cover-alt is-active">
          <input type="checkbox" [disabled]="class?.disabled === 1 ? 'disabled':null" name="checkbox-example-1"
            (click)="checkRadio(class, $event)" />
            <span class="custom-input__label">
              <img src="/assets/icn/class/sm-benefit.svg" class="icon" alt="" />
              <h5 class="font-16">{{class?.answer}}</h5>
              <p class="readmore readmore--inline" data-widget="ReadMore" data-splitlength="15"
              data-more-text="read more" data-less-text="read less" [innerHTML]="class?.info_comment"></p>
              <span *ngIf="class?.del === 1" class="custom-input__actions">
                <a href="javascript:;" data-toggle="modal" (click)="removeClassItem(class, 1)"
                  class="icon-hover icon-hover--mobile-label" data-tooltip="tooltip" data-placement="top" title=""
                  data-original-title="Remove Cover" tabindex="0">
                  <svg class="icon icon--sm">
                    <use xlink:href="#trash-bin"></use>
                  </svg>
                  <strong>Remove</strong>
                </a>
                <a href="javascript:;" *ngIf="class?.edit === 1" (click)="editModal(class)"
                  class="icon-hover icon-hover--mobile-label" data-tooltip="tooltip" data-placement="top" title=""
                  data-original-title="Edit Cover" tabindex="0">
                  <svg class="icon icon--sm">
                    <use xlink:href="#edit-underline"></use>
                  </svg>
                  <strong>Edit</strong>
                </a>
              </span>
            </span>
            <span *ngIf="class?.edit === 0" class="custom-input__indi"></span>
            <span *ngIf="class?.edit === 1 && class?.item_detail" class="custom-input__price">
              <p><strong>{{class?.item_detail[0]?.prem_value}}</strong>/{{questionService.currency?.display_freq}}</p>
            </span>
          </label>
        </div>
      </div>

    </div> -->
  </div>

<!-- <div class="form-group form-group--sm">
<label
  class="custom-input custom-input--radio custom-input--pill-complex"
  >
  <input
    type="radio"
    (click)="nothinMore($event)"
    name="nothing-more"/>
    <span class="custom-input__indi"></span>
    <span class="custom-input__label">Nothing More</span>
  </label>
</div> -->
<!-- DUMMY: wording modal - no wording in getSuperTrafficCop yet -->
<div class="modal fade modal--mini" id="traffic-wording-modal" tabindex="-1" role="dialog" aria-labelledby="traffic-wording-modal" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-mini">
      <div class="modal-mini__heading">
        <div class="container-fluid">
          <h4>Lorem ipsum dolor sit amet.</h4>
        </div>
      </div>
      <div class="modal-mini__content">
        <div class="container-fluid">
          <div class="rte">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris tristique ultricies quam sed efficitur. Nullam ac sodales dui. Morbi vel tortor scelerisque, egestas enim id,
              consequat lacus. Duis malesuada urna a varius sagittis. Donec varius quam quis mauris pellentesque facilisis. Proin eleifend luctus faucibus.
            </p>
            <h5>Lorem ipsum dolor sit amet.</h5>
            <table class="table table--minimal">
              <thead>
                <tr>
                  <th>Extension Name</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                @for (row of [1, 2, 3, 4, 5, 6, 7, 8]; track row) {
                  <tr>
                    <td>[Label]</td>
                    <td>[Text]</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-mini__button">
        <div class="container-fluid">
          <a href="#" data-dismiss="modal" class="button button--primary">Okay</a>
        </div>
      </div>
    </div>
  </div>
</div>
@if (removeModal?.length > 0) {
  <dialog class="dialog" id="remove-section-modal">
    <div class="dialog-inner">
      <div class="dialog-content modal-alert modal-alert--alt">
        <div class="modal-alert__heading">
          <div class="container">
            <div class="modal-alert__avatar">
              <img src="assets/{{question?.category_id}}/avatar/happy.png" class="img-fluid" alt="">
            </div>
            <a href="#" class="modal-alert__close" data-dismiss="dialog">
              <svg class="icon">
                <use xlink:href="#close-medium"></use>
              </svg>
            </a>
          </div>
        </div>
        <div class="modal-alert__content">
          <div class="container">
            <div class="rte text-left">
              <h4>{{removeModal[0]?.value}}</h4>
              <ul [innerHTML]="removeModal[1]?.value">
              </ul>
            </div>
          </div>
        </div>
        <div class="modal-alert__button">
          <div class="container">
            <a href="#" data-toggle="modal" data-dismiss="dialog" class="button button--lg button--secondary">No, keep it</a>
            <a id="remove-cover-btn" href="javascript:;" (click)="removeConfirmed()" data-toggle="modal" data-dismiss="dialog" class="button button--lg button--primary">Yes, remove it</a>
          </div>
        </div>
      </div>
    </div>
    <div class="ui-selectmenu-menu ui-front"><ul aria-hidden="true" aria-labelledby="ui-id-1-button" id="ui-id-1-menu" role="listbox" tabindex="0" class="ui-menu ui-corner-bottom ui-widget ui-widget-content"></ul></div>
  </dialog>
}



